import { Button, Grid, Paper, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { ReactComponent as Logout } from "../../Assets/Images/Icon/LogoutICON.svg";
import { ReactComponent as Passowrd } from "../../Assets/Images/Icon/PasswordICON.svg";
import { ReactComponent as SettingsIcon } from "../../Assets/Images/Icon/SettingsICON.svg";
import { HorizontalDivide } from "../../Components/atoms/HorizontalDivide/HorizontalDivide";
import {
  Heading1,
  Heading2,
} from "../../Components/atoms/Typography/Heading/Heading";
import { Text } from "../../Components/atoms/Typography/Text/Text";
import TextGroupType5 from "../../Components/molecules/TextGroup/TextGroupType5";
import { ChangePassword } from "../../Components/organisms/ChangePassword/ChangePassword";
import ConfirmDialog from "../../Components/organisms/ConfirmDialog/ConfirmDialog";
import { useAuth } from "../../Store/AuthContext";
import { Theme } from "../../Style/Theme";
import useOverlayState from "../../Utils/Hooks/useOverlayState";

export const Settings = () => {
  const { t } = useTranslation();
  const { OverlayState, openOverlay, closeOverlay } = useOverlayState();
  const { state } = useAuth();
  let navigate = useNavigate();

  const logoutHandler = () => {
    localStorage.removeItem("doctore");
    localStorage.removeItem("UserName");
    navigate("/");
  };

  return (
    <>
      <Grid container direction={"column"}>
        <Grid item>
          <Stack direction={"row"} justifyContent={"space-between"} mb={2.8}>
            <Heading1 text={t("glossary:settings.title")} />
          </Stack>
        </Grid>
        <Grid item>
          <Paper
            sx={{
              padding: "20px 24px",
              boxShadow: "0px 0px 25px 0px rgba(0, 0, 0, 0.05)",
              borderRadius: "10px",
            }}
          >
            <Grid container direction={"column"} spacing={1}>
              <Grid item>
                <Heading2
                  icon={<SettingsIcon />}
                  text={t("glossary:settings.account-settings")}
                />
              </Grid>
              <Grid item marginLeft={"26px"}>
                <TextGroupType5
                  heading={t("glossary:settings.email")}
                  SubText={state?.email ?? state?.user?.email}
                />
              </Grid>
              <Grid item marginLeft={"26px"}>
                <HorizontalDivide
                  marginBottom={"16px"}
                  height={"0.5px"}
                  marginTop={"16px"}
                />
              </Grid>
              <Grid item marginLeft={"26px"}>
                <Paper
                  variant="LightPearlGrey"
                  sx={{
                    padding: "20px 16px",
                    width: "100%",
                  }}
                >
                  <Stack
                    direction={"row"}
                    justifyContent={"flex-start"}
                    width={"100%"}
                    spacing={2}
                  >
                    <Button
                      sx={{
                        width: "170px",
                        borderRadius: "14px",
                        padding: "48px 30px",
                        background: Theme.palette.background.pureWhite,
                        ":hover": {
                          background: Theme.palette.background.pureWhite,
                        },
                      }}
                      onClick={() => {
                        openOverlay({
                          OverlayName: "change-password",
                        });
                      }}
                    >
                      <Stack
                        justifyContent={"center"}
                        alignItems={"center"}
                        gap={"13px"}
                      >
                        <Passowrd style={{ width: "66px", height: "32px" }} />
                        <Text
                          text={t("glossary:settings.change-password")}
                          color={Theme.palette.blue.primaryBlue}
                        />
                      </Stack>
                    </Button>

                    <Button
                      onClick={() =>
                        openOverlay({
                          OverlayName: "logout",
                        })
                      }
                      sx={{
                        width: "170px",
                        borderRadius: "14px",
                        padding: "48px 30px",
                        background: Theme.palette.background.pureWhite,
                        ":hover": {
                          background: Theme.palette.background.pureWhite,
                        },
                      }}
                    >
                      <Stack
                        justifyContent={"center"}
                        gap={"13px"}
                        alignItems={"center"}
                      >
                        <Logout style={{ width: "35px", height: "32px" }} />
                        <Text
                          text={t("glossary:settings.logout")}
                          color={Theme.palette.blue.primaryBlue}
                        />
                      </Stack>
                    </Button>
                  </Stack>
                </Paper>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
      {OverlayState.OverlayName === "change-password" && (
        <ChangePassword
          openDrawer={OverlayState.visible}
          close={closeOverlay}
        />
      )}
      {OverlayState.OverlayName === "logout" && (
        <ConfirmDialog
          open={OverlayState.visible}
          close={closeOverlay}
          title={t("glossary:settings.logout")}
          description={t("common:alert-confirm:proceed-confirm-logout")}
          onOkClick={() => {
            //logout action
            logoutHandler();
            closeOverlay();
          }}
          onOkTitle={t('common:alert-confirm.yes')}
          onCancelClick={closeOverlay}
          onCancelTitle={t('common:alert-confirm.no')}
        />
      )}
    </>
  );
};
